module.exports = __webpack_public_path__ + "img/weg.b8b4ef9f.jpg";